module.exports = __webpack_public_path__ + "img/play_arrow.1b194e22.svg";